import { useDispatch } from '@redux';
import { moveToPending } from '@redux/orders/actions';
import { Modal, Form, Input } from 'antd';
import FormItem from 'components/form/FormItem';
import { RestInputContext } from 'components/form/RestInputContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

interface IMoveToPendingModalProps {
  id?: string;
  visible?: boolean;
  onCancel?: () => void;
}

const MoveToPendingModal = ({
  id,
  visible,
  onCancel,
}: IMoveToPendingModalProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  // const handleSubmit = (values) => {
  //   dispatch(moveToPending({ data: { id: id, data: values } })).then((res) => {
  //     if (res?.payload?.success) {
  //       onCancel();
  //       window.location.reload();
  //     }
  //   });
  // };

  const handleSubmit = async (values) => {
    setLoading(true);
    await dispatch(
      moveToPending({
        data: {
          id: id,
          data: values,
        },
        options: {
          isShowSuccessNoti: true,
        },
      }),
    )
      .then((res: DynamicObjectType) => {
        if (res?.payload?.success) {
          onCancel();
          setLoading(false);
          window.location.reload();
        }
      })
      .then(() => setLoading(false));
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      onOk={() => {
        form.submit();
      }}
      okButtonProps={{
        loading,
      }}
      title={t('Move to Pending')}
    >
      <RestInputContext.Provider value={{ form }}>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <FormItem name="confirmMoveNote" label={t('Reason')}>
            <Input.TextArea />
          </FormItem>
        </Form>
      </RestInputContext.Provider>
    </Modal>
  );
};

export default MoveToPendingModal;
